import {Dimensions, Image, Text, View} from "react-native";
import styles from "./styles";
import Swiper from "react-native-web-swiper";
import {ImageBackground} from "react-native-web";

const { height, width } = Dimensions.get("window");

export default function OfferBanner(props){
    return(
            <View style={{flex:1}}>
                <Swiper
                    style={styles.slideContainer}
                    timeout={5}
                    loop
                    controlsProps={{
                        dotsWrapperStyle:{marginBottom:40},
                        prevPos: false,
                        nextPos: false,
                    }}
                >
                    { props.appData.slides.map((slide) => {
                        return(
                            <View key={slide.slide_image.ID} style={styles.slideContainer}>
                                <ImageBackground
                                    source={{uri:slide.slide_image.url}}
                                    style={{width:'100%',height:undefined,aspectRatio: 5/7 ,resizeMode:'cover',marginVertical:0,paddingVertical:0}}
                                >
                                    {slide.caption ?
                                        <View style={styles.slideTextHolder}>
                                            <View style={styles.slideTextBG}>
                                                <Text style={styles.slideText}>{slide.caption}</Text>
                                            </View>
                                        </View>
                                        :
                                        <></>
                                    }

                                </ImageBackground>
                            </View>
                        )
                    })}
                </Swiper>
            </View>
    )
}